export const byCompanyTable = {
    company: 'Company ',
    clusterID: 'Cluster ID',
    selected: 'Selected',

    // クラスタの特許出願一覧
    patentList: 'List of Patent Applications in the Cluster',
    displayAllPatent: 'Displaying all patent applications owned by the company',
    sortDescription: '*You can sort multiple columns by clicking each header while pressing Shift key.',
    column1: 'Cluster ID',
    column2: 'Publication Number/Patent Number',
    column3: 'Main IPC',
    column4: 'Other IPC',
    column5: 'Title',
    column6: 'Owner of the Patent Application',
    column7: 'Inventor',
    column8: 'Factor Load Quantity',
    column9: 'Forward Citations',
    column10: 'Application Year',
    column11: 'Material Patent',

    // クラスタの特許出願推移
    timeSeriesOfPatent: 'Time Series of Patent Applications in the Cluster',
    timeSeriesOfPatentDescription: `This displays the time series of the cluster's all patent applications owned by the company selected for "Inter-company Analysis".`,
    notice: 'Please select a cluster to display data.',
    legend: 'Company Name',
    xAxis: 'Year',
    yAxis: 'Number of Patent Applications',

    // patentListCsvのヘッダー
    patentListColumn1: 'Cluster ID',
    patentListColumn2: 'Publication Number/Patent Number',
    patentListColumn3: 'Main IPC',
    patentListColumn4: 'Other IPC',
    patentListColumn5: 'Title',
    patentListColumn6: 'Owner of the Patent Application',
    patentListColumn7: 'Registered Country',
    patentListColumn8: 'Inventor',
    patentListColumn9: 'Factor Load Quantity',
    patentListColumn10: 'Forward Citations',
    patentListColumn11: 'Application Year',
    patentListColumn12: 'Material Patent',

    // patentByYearListCsvのヘッダー
    patentListByYearColumn1: 'Company Name',
    patentListByYearColumn2: 'Registered Country',
    patentListByYearColumn3: 'Year',
    patentListByYearColumn4: 'Patent Count'
}
